import { Link } from '@tanstack/react-router';
import { useI18n } from '../i18n';
import { AuthCard } from '../layout';

/**
 * A phone link (/m/…) opened in a browser instead of the app: the app opens these by itself when it is installed
 * (universal links), so here it only says how.
 */
export function PhoneLinkPage() {
  const { t } = useI18n();
  return (
    <AuthCard eyebrow="FakturaSmart Pro" title={t('Atidarykite programėlėje')}
      intro={t('Ši nuoroda skirta FakturaSmart Pro programėlei telefone. Įdiekite programėlę, prisijunkite ir nuskaitykite QR kodą dar kartą telefono kamera.')}
      footer={<Link to="/login">{t('Prisijungti')}</Link>}>
      {null}
    </AuthCard>
  );
}
